import styled, { css } from 'styled-components';
import { ToggleWrapper as CourseListingToggleWrapper } from 'Modules/Filters/CourseListing/CourseListing.styled';

export const Option = styled.span`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        margin: 0rem;
        font-size: 1.125rem;
        font-weight: 400;
        min-width: 2.25rem;

        ${CourseListingToggleWrapper} & {
            color: ${theme.colors.accents[25].hex};
            font-size: 1rem;
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.5rem;
            font-weight: 300;

            ${CourseListingToggleWrapper} & {
                font-size: 1rem;
            }
        }
    `}
`;

export const Container = styled.div<{ $isActive?: boolean }>`
    ${({ $isActive, theme }) => css`
        display: flex;
        align-items: center;

        ${CourseListingToggleWrapper} & {
            margin-top: 1rem;
        }

        ${$isActive
            ? css`
                  ${Option}:last-of-type {
                      color: ${theme.colors.tertiary.hex};
                      font-weight: bold;
                  }
              `
            : css`
                  ${Option}:first-of-type {
                      font-weight: bold;
                      color: ${theme.colors.tertiary.hex};
                  }
              `}
    `}
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        display: flex;
        position: relative;
        background-color: inherit;
        align-items: center;
        width: 3rem;
        height: 1.6rem;
        margin: 0 0.8rem;
        border: 0.06rem solid ${theme.colors.tertiary.hex};
        border-radius: 1rem;
        cursor: pointer;

        ${CourseListingToggleWrapper} & {
            background-color: ${theme.colors.tertiary.hex};

            :focus {
                outline: 0.3rem solid white;
            }
        }

        &:after {
            transition: ease-in 0.2s;
            content: '';
            width: 1.25rem;
            height: 1.25rem;
            background: ${theme.colors.tertiary.hex};
            ${CourseListingToggleWrapper} & {
                background: ${theme.colors.primaryContrast.hex};
            }
            border-radius: 50%;
            position: absolute;
            left: 0.13rem;
            ${$isActive && `left: 1.5rem;`}
        }
    `}
`;
